<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20 20H0V0H20V20ZM1.25 18.75H18.75V1.25H1.25V18.75Z"
    fill="currentColor"
/>
<path
    d="M10 1.66667L12.2042 6.96619L17.9255 7.42486L13.5665 11.1588L14.8982 16.7418L10 13.75L5.10179 16.7418L6.43354 11.1588L2.07453 7.42486L7.7958 6.96619L10 1.66667Z"
    fill="currentColor"
/>
